import './style.scss';
import BeneficiaryRow from "../beneficiaryRow";

function BeneficiaryItem({ itemsDescription, beneficiaries }) {
  return (
    <div className='itemsBeneficiaries-description-container'>
      <div className='description-container'>
        {itemsDescription.length > 0 &&
          itemsDescription.map((itemD, i) => <p key={i}>{itemD.name}</p>)}
      </div>
      {beneficiaries.length > 0 &&
          beneficiaries.map((beneficiary, i) => (
          <BeneficiaryRow key={i} beneficiary={beneficiary} />
        ))}
    </div>
  );
}
export default BeneficiaryItem;
